import Prism from "prismjs";

/**
 * Publie `Prism` en global AVANT que ses grammaires ne soient chargées.
 *
 * Les modules `prismjs/components/*` ne sont pas des modules ES : ce sont des
 * scripts qui s'attachent à un `Prism` global au moment de leur évaluation. Un
 * `import Prism from "prismjs"` en revanche ne publie rien sur `globalThis` — la
 * grammaire lève alors `Prism is not defined`, et comme l'erreur survient au
 * chargement du module, c'est TOUTE l'application qui ne démarre pas.
 *
 * Pourquoi un fichier séparé plutôt qu'une ligne dans `editor.tsx` : en ESM, les
 * imports d'un module sont tous évalués avant son corps. Une affectation écrite
 * entre les imports s'exécuterait donc APRÈS les grammaires, c'est-à-dire trop
 * tard. Les dépendances, elles, sont évaluées dans leur ordre de déclaration :
 * importer ce module avant les `prismjs/components/*` garantit le bon ordre.
 */
(globalThis as typeof globalThis & { Prism?: typeof Prism }).Prism = Prism;

export default Prism;
